// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { icon } from '../../tokens/themeColors/icon';
import { text } from '../../tokens/themeColors/text';
export var radioColors = function(mode) {
    var bg = background(mode);
    var bd = border(mode);
    var ic = icon(mode);
    var tx = text(mode);
    return {
        default: {
            border: bd.active,
            labelText: tx.primary
        },
        checked: {
            knob: ic.active,
            border: bd.heavy
        },
        disabled: {
            border: bd.soft,
            knob: ic.disabled,
            labelText: tx.disabled
        },
        focus: {
            border: bd.actionBold
        },
        hover: {
            background: bg.state.hover0,
            border: bd.heaviest
        }
    };
};

//# sourceMappingURL=radioColors.js.map